



































import { Component, Vue } from 'vue-property-decorator';
import { TransferAccountModel } from '@/services/api/nswag/stapiclient_generated';
import { stTransferAccountApi } from '@/services/st-api';
import StInput2 from '@/components/basic/StInput2.vue';

@Component({
  components: {
    StInput2,
  },
})
export default class TransferAccount extends Vue {
  private loading: boolean = false;

  private guid: string = '';

  created() {
    this.guid = this.$route.params.guid;
  }

  async submit() {
    this.loading = true;
    try {
      const model = new TransferAccountModel();
      model.guid = this.guid;
      await stTransferAccountApi.transferAccount(model);
      await this.$router.push('/login');
    } finally {
      this.loading = false;
    }
  }
}
